export default __webpack_public_path__ + "static/media/03-minuatura-transmision.ffa80338.jpg";